<section class="blog single-blog section" style="padding-top: 10px !important;">
    <div class="container container-xs">
        <div class="row">
            <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12  animated fadeIn">
                <div class="row" *ngIf="loadingPreguntas || loadingValores">
                    <div class="col-12">
                        <div class="alert alert-info text-center">
                            <h4 class="alert-heading">Cargando</h4>
                            <i class="fa fa-sync fa-spin fa-3x"></i>
                            <p class="mb-0">Espera por favor...</p>
                        </div>
                    </div>
                </div>
                <div class="caminodemigas">
                    <a href="#"><i _ngcontent-hdm-c23="" class="fa fa-1x fa-home mr-1"></i> </a>
                    <span><a (click)="gotoTemas(burbujaId)" > {{(burbuja?.length>24)? (burbuja | slice:0:24)+'..':(burbuja)}} </a> <i class="fas fa-chevron-right"></i>  {{(tema?.length>24)? (tema | slice:0:24)+'..':(tema)}} </span>
                </div>
                <h1 class="tema"><a type="button" class="btn btn-link" (click)="volver()"><i class="fas fa-arrow-left"></i> </a> {{tema}}</h1>

                <div *ngIf="loadingPreguntas==false && preguntas.length==0">
                    <label><i class="fas fa-exclamation"></i> No encontramos preguntas para este tema.</label>
                </div>
                <div class="mt-3">
                    <button type="button" (click)="habilitarOrdenar()" data-toggle="tooltip" title="Habilitar Ordenamiento" *ngIf="isAdmin && !ordenar &&  preguntas.length>0" class="btn btn-outline-primary ordenar btn-sm"><i class="fas fa-sort"></i> Ordenar</button>
                    <button type="button" (click)="nuevaPregunta(temaId)" data-toggle="tooltip" title="Nueva Pregunta" *ngIf="(isAdmin||isContribuidor) && editar" class="btn btn-primary nuevaburbuja btn-sm"><i class="fas fa-plus"></i> Nueva pregunta</button>
                    <button type="button" (click)="cancelarOrdenar()" *ngIf="isAdmin && ordenar" class="btn btn-outline-primary deshabilitar btn-sm"><i class="fas fa-times"></i> Cancelar</button>
                    <button type="button" (click)="guardarOrdenamiento()" *ngIf="isAdmin && ordenar" class="btn btn-outline-success guardar btn-sm"><i class="far fa-save"></i> Guardar</button>

                    <div cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenar" [cdkDropListData]="preguntas" class="burbujalineal">
                        <div class="list-group" *ngFor="let pregunta of preguntas; let i = index" cdkDrag>
                            <span class="list-group-item list-group-item-action" (mouseenter)="hoveredIndex = i" (mouseleave)="hoveredIndex = null">
                            <a (click)="responderPregunta(pregunta.id)" >{{pregunta.enunciado}}</a>&nbsp;
                            <a (click)="editarPregunta(pregunta.id)" data-toggle="tooltip" title="Editar Pregunta" *ngIf="(isAdmin||isContribuidor) && hoveredIndex == i"><i class="fa fa-1x fa-edit"></i></a>
                            <a (click)="borrarPregunta(pregunta.id, pregunta.enunciado)" data-toggle="tooltip" title="Eliminar Pregunta" *ngIf="(isAdmin) && hoveredIndex == i"><i class="fa fa-1x fa-trash-alt"></i></a>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
</section>
